import { BaseContainerModel } from '../base-container.model';
import {bl_fi_mst_branch_settlement_method_import_file_hdr_RowClass, bl_fi_mst_branch_settlement_method_import_file_hdr_RowInterface}
from '../../dbschema/index';

export class BranchSettlementMethodImportFileHdrContainerModel extends BaseContainerModel {
    bl_fi_mst_branch_settlement_method_import_file_hdr: bl_fi_mst_branch_settlement_method_import_file_hdr_RowClass = new bl_fi_mst_branch_settlement_method_import_file_hdr_RowClass();
}